/**
 * Derive the inbox preview line from an email body — the same rule the backend
 * applies at send time (core/services/email_templates.derive_preview_text), so
 * what the agent SEES in the Preview text field matches what actually sends
 * (CG, Monday 12975097413: "preview text not auto populating" — the server-side
 * default filled it invisibly; the field itself must populate).
 *
 * First sentence of the visible copy, HTML + merge tags stripped, capped on a
 * word boundary. Returns '' when the body has no usable text (the field then
 * stays blank and the server falls back to the subject).
 */
export function derivePreviewFromBody(bodyHtml, limit = 110) {
  if (!bodyHtml) return '';
  let text = String(bodyHtml)
    // Whole style/script blocks and any hidden element (a branded document's
    // preheader div) would otherwise become the "first sentence".
    .replace(/<style[\s\S]*?<\/style>/gi, ' ')
    .replace(/<script[\s\S]*?<\/script>/gi, ' ')
    .replace(/<[^>]*display\s*:\s*none[\s\S]*?>[\s\S]*?<\/[a-z]+>/gi, ' ')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\{\{[^}]+\}\}/g, '')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&');
  text = text.replace(/\s+/g, ' ').replace(/\s+([.,!?;:])/g, '$1').trim();
  if (!text) return '';
  const first = text.split(/(?<=[.!?])\s/)[0].trim();
  if (first.length <= limit) return first;
  let cut = first.slice(0, limit);
  const lastSpace = cut.lastIndexOf(' ');
  if (lastSpace > 0) cut = cut.slice(0, lastSpace);
  return cut.replace(/[\s,;:-]+$/, '');
}
